'use client';

import Script from 'next/script';
import { usePathname } from 'next/navigation';

export default function AnalyticsScripts() {
  const pathname = usePathname();

  // Local QA must not send PageView or conversion noise to the live pixel.
  if (process.env.NODE_ENV !== 'production') return null;

  // A personal booking URL holds a bearer token in its fragment. Keep third
  // party analytics libraries off that page, including on direct entry.
  if (pathname === '/book-demo/l' ||
      (typeof window !== 'undefined' && window.location.pathname === '/book-demo/l')) return null;

  return (
    <>
      <Script id="meta-pixel" strategy="afterInteractive">
        {`
          var meta2Qa = location.pathname === '/book-demo/meta2' &&
            new URLSearchParams(location.search).get('qa') === '1';
          try { meta2Qa = meta2Qa ||
            (location.pathname === '/book-demo/meta2' && sessionStorage.getItem('ig_meta2_qa') === '1');
          } catch (e) {}
          if (!meta2Qa) {
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '2269017683874310');
          fbq('track', 'PageView');
          }
        `}
      </Script>
      <Script src="https://www.googletagmanager.com/gtag/js?id=G-X7RLCKC432" strategy="lazyOnload" />
    </>
  );
}
